import { render, staticRenderFns } from "./BotonPrincipal.vue?vue&type=template&id=2417671e&scoped=true"
import script from "./BotonPrincipal.vue?vue&type=script&lang=js"
export * from "./BotonPrincipal.vue?vue&type=script&lang=js"
import style0 from "./BotonPrincipal.vue?vue&type=style&index=0&id=2417671e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2417671e",
  null
  
)

export default component.exports